import React from 'react'
import './FormField.css'
import CurrencyInput from 'react-currency-input-field'

import FormField from './FormField'

const FormCurrencyInput = (props) => {
  const {
    id,
    name,
    className,
    label,
    header,
    icon,
    noMargin,
    defaultValue,
    decimalsLimit,
    ...inputProps
  } = props

  return (
    <div
      className={
        'form-field' +
        (className ? ' ' + className : '') +
        (noMargin ? ' mb-1' : ' mb-3')
      }
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      {header}
      <div className='form-input'>
        {icon ? <i className={'form-icon mdi mdi-' + icon}></i> : ''}
        <CurrencyInput
          id={id}
          name={name}
          value={defaultValue}
          decimalsLimit={decimalsLimit}
          customInput={FormField}
          onValueChange={(value, name) => props.onValueChange(value, name)}
          {...inputProps}
        />
      </div>
    </div>
  )
}

export default FormCurrencyInput
